/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef } from 'react'
import { PieChart, Pie, Cell, Legend, Label } from 'recharts'

const PDFDonutChart = ({ label, data, width = 500, height = 500, onLoaded }) => {
  const chartRef = useRef()
  const hasLoaded = useRef(false)

  // 自定義顏色
  const colorPalette = [
    '#ff9900',
    '#a4c619',
    '#52b76a',
    '#b75275',
    '#8700ff',
    '#ef0909',
    '#722727',
    '#2c6372',
  ]

  const filteredData = data.filter(item => item.value > 0) // 過濾掉 0 的項目

  // 這裡生成顏色映射，基於原始 data
  const colorMapping = data.reduce((acc, item, index) => {
    if (item.value > 0) {
      acc.push(colorPalette[index])
    }
    return acc
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasLoaded.current) {
        hasLoaded.current = true
        onLoaded?.(chartRef.current)
      }
    }, 100)

    return () => {
      clearTimeout(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      ref={chartRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '20px',
        border: '4px solid rgb(182, 180, 180)', // 包圍整體的邊框
        width: '100%', // 確保容器的寬度足夠
        boxSizing: 'border-box', // 讓邊框也計算在內
        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.3)', // 增強陰影效果，讓陰影更為明顯
        overflow: 'hidden', // 確保陰影可見
      }}
    >
      {filteredData.length > 0 ? (
        <PieChart width={width} height={height}>
          <Pie
            data={filteredData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="30%"
            outerRadius={120}
            innerRadius={90}
            label={({ percent }) => (percent > 0 ? `${(percent * 100).toFixed(0)}%` : '')}
          >
            {filteredData.map((_, index) => (
              <Cell key={`cell-${index}`} fill={colorMapping[index]} />
            ))}
            <Label
              value={`釣中人數${label}人`}
              position="center"
              style={{ fontSize: 17, fontWeight: 'bold', fill: '#000' }}
            />
          </Pie>
        </PieChart>
      ) : (
        <PieChart width={width} height={height}>
          <Pie
            data={[{ name: '無資料', value: 1 }]} // 假資料
            dataKey="value"
            cx="50%"
            cy="30%"
            outerRadius={0} // 不畫出外圈
            innerRadius={0} // 不畫出內圈
            isAnimationActive={false}
          >
            <Cell fill="#e0e0e0" />
            <Label
              value="本次演練總釣中人數: 0人"
              position="center"
              style={{ fontSize: 20, fontWeight: 'bold', fill: '#000' }}
            />
          </Pie>
        </PieChart>
      )}

      {/* 圖例下方顯示，調整距離並確保每行兩個圖例 */}
      <Legend
        wrapperStyle={{
          display: 'flex',
          flexDirection: 'row', // 水平排列
          justifyContent: 'center', // 圖例居中
          flexWrap: 'wrap', // 自動換行
          marginBottom: 50, // 圖例與圓環之間的間距，增大此值來調整間距
        }}
        content={() => (
          <ul
            style={{
              padding: 0,
              margin: 0,
              listStyle: 'none',
              textAlign: 'center',
              paddingLeft: '100px',
            }}
          >
            {data.map((entry, index) => (
              <li
                key={`item-${index}`}
                style={{
                  display: 'inline-flex', // 使用 inline-flex 保證內部元素垂直居中
                  alignItems: 'center', // 保證顏色方塊和文字垂直居中
                  width: '35%', // 每項目寬度（50% 的寬度減去一些間距）
                  textAlign: 'center',
                  marginBottom: '10px', // 每列之間的距離
                  marginRight: '5%', // 每項目之間的水平間距
                }}
              >
                <span
                  style={{
                    display: 'inline-block',
                    width: '12px', // 確保方塊的寬度一致
                    height: '12px', // 確保方塊的高度一致
                    backgroundColor: colorPalette[index],
                    marginRight: '8px', // 圖例顏色與文字間的間距
                  }}
                ></span>
                {entry.name}
              </li>
            ))}
          </ul>
        )}
      />
    </div>
  )
}

export default PDFDonutChart
